export default "__VITE_ASSET__BzNxnMWO__"